import Vue from 'vue'
import VueRouter from 'vue-router'

// register router plugin
Vue.use(VueRouter)

// initiate router with options
let router = new VueRouter({
    suppressTransitionError: true,
    transitionOnLoad: true,
    history: true,
    hashbang: false
})

// async routes
router.map({
    '/': {
        name: 'home',
        component: function (resolve) {
            require(['./pages/Home'], resolve)
        }
    },
    '/view-graham': {
        name: 'view',
        component: function (resolve) {
            require(['./pages/View'], resolve)
        }
    },
    '/graham/:hotspot': {
        name: 'graham',
        component: function (resolve) {
            require(['./pages/View'], resolve)
        }
    },
    '/about-the-project': {
        name: 'about',
        component: function (resolve) {
            require(['./pages/About'], resolve)
        }
    },
    '/the-broader-context': {
        name: 'context',
        component: function (resolve) {
            require(['./pages/Context'], resolve)
        }
    },
    '/education': {
        name: 'educational',
        component: function (resolve) {
            require(['./pages/Educational'], resolve)
        }
    },
    '/privacy-policy': {
        name: 'privacy',
        component: function (resolve) {
            require(['./pages/Privacy'], resolve)
        }
    },
    '/accessibility': {
        name: 'accessibility',
        component: function (resolve) {
            require(['./pages/Accessibility'], resolve)
        }
    },
    '/disclaimer': {
        name: 'disclaimer',
        component: function (resolve) {
            require(['./pages/Disclaimer'], resolve)
        }
    }
})

// beforeEach route change
router.beforeEach(function (transition) {

    let isPreloadingDisabled = (transition.from.name === 'graham' && transition.to.name === 'view') ||
        (transition.to.name === 'graham' && transition.from.name === 'view') ||
        (transition.to.name === 'graham' && transition.from.name === 'graham')

    // Do we display the main preloader?
    if (isPreloadingDisabled) {
        transition.next()
    } else {
        router.app.$root.$emit('loading-start')
        transition.next()
    }

    // We are leaving the viewport
    router.app.$emit('viewport-unbind', transition.from.name)

})

// afterEach route change
router.afterEach(function (transition) {

    // set user scroll to initial position
    window.scrollTo(0, 0)

    // SVG not supported => fallback PNG
    let isIE = transition.to.router.app.$store.state.isBrowserIE
    if (isIE || !Modernizr.svg) {
        let imgs = router.app.$el.querySelectorAll('[data-fallback-src]')
        for (let i = 0; i !== imgs.length; i++) {
            imgs[i].src = imgs[i].getAttribute('data-fallback-src')
            imgs[i].removeAttribute('data-fallback-src')
        }
    }

    // Viewport is ready
    router.app.$emit('viewport-bind', transition.to.name)

})

// default route
router.redirect({
    '*': '/'
})

// export the router instance
export default router



// WEBPACK FOOTER //
// ./src/router.js